import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RocketLaunchIcon from '@mui/icons-material/EmojiEvents';

import {
    markWelcomeSeen,
    openChecklist,
    startTour,
} from '../../../redux/actions/onboarding';
import { isAuthRoute, TOUR_IDS } from '../configs/onboarding.config';

class WelcomeModal extends Component {
    shouldRender = () => {
        const { userSession, onboarding, location } = this.props;

        // Gate 1: usuario logado
        if (!userSession?.user) return false;

        // Gate 2: pre-login (login, password-reset, etc)
        if (isAuthRoute(location?.pathname)) return false;

        // Gate 3: defesa em profundidade — sem accesstoken nao logou ainda
        if (!localStorage.getItem('accesstoken')) return false;

        // Gate 4: backend ainda nao respondeu ou audience vazia (onboarding desligado pra esse hirer)
        if (!onboarding?.loaded) return false;
        if (!onboarding?.audience) return false;

        // Gate 5: ainda nao viu o welcome (welcomeSeen === false)
        return onboarding?.welcomeSeen === false;
    };

    handleSkip = () => {
        this.props.markWelcomeSeen();
    };

    handleStartTour = () => {
        this.props.markWelcomeSeen();
        // Dispara o tour System Overview — apresenta a tela principal
        // de listagem de chamados (topbar, drawers, filtros). Se o user
        // ja nao estiver em /pt/calleds, navega antes (o tour funciona
        // melhor com a tela alvo). O checklist abre automaticamente
        // quando este tour terminar (ProductTour.finishTour cuida disso).
        const lang = this.props?.match?.params?.lang || 'pt';
        const targetRoute = `/${lang}/calleds`;
        if (window?.location?.pathname !== targetRoute) {
            this.props.history.push(targetRoute);
        }
        // Pequeno atraso pra navegacao SPA processar antes de iniciar tour
        setTimeout(() => this.props.startTour(TOUR_IDS.SYSTEM_OVERVIEW), 200);
    };

    getDescriptionKey = () => {
        const audience = this.props.onboarding?.audience;
        if (audience === 'dedicated') return 'onboarding.welcome.description.dedicated';
        return 'onboarding.welcome.description.trial';
    };

    render() {
        if (!this.shouldRender()) return null;

        const { userSession, intl } = this.props;
        const userName = (userSession?.user?.name || '').split(' ')[0] || '';

        const title = userName
            ? intl.formatMessage({ id: 'onboarding.welcome.title' }, { name: userName })
            : intl.formatMessage({ id: 'onboarding.welcome.title.fallback' });

        return (
            <Dialog
                open
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { borderRadius: '16px' } }}
            >
                <Box sx={{ position: 'relative', p: 4, textAlign: 'center' }}>
                    <IconButton
                        aria-label={intl.formatMessage({ id: 'onboarding.tour.close' })}
                        onClick={this.handleSkip}
                        sx={{ position: 'absolute', right: 12, top: 12, color: '#999' }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Box
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: '50%',
                            backgroundColor: '#e8f5e9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                        }}
                    >
                        <RocketLaunchIcon sx={{ color: '#8BC34A', fontSize: 40 }} />
                    </Box>

                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 700, color: '#212121', mb: 1 }}
                    >
                        {title}
                    </Typography>

                    <Typography variant="body1" sx={{ color: '#555', mb: 2 }}>
                        {intl.formatMessage({ id: this.getDescriptionKey() })}
                    </Typography>

                    <DialogContent sx={{ px: 0, py: 0 }}>
                        <Typography variant="body2" sx={{ color: '#777', mb: 2 }}>
                            {intl.formatMessage({ id: 'onboarding.welcome.subtext' })}
                        </Typography>
                    </DialogContent>

                    <DialogActions
                        sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 1, p: 0, mt: 1 }}
                    >
                        <Button
                            variant="outlined"
                            onClick={this.handleSkip}
                            sx={{
                                borderColor: '#bdbdbd',
                                color: '#555',
                                textTransform: 'none',
                                fontWeight: 500,
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            {intl.formatMessage({ id: 'onboarding.welcome.btn.skip' })}
                        </Button>

                        <Button
                            variant="contained"
                            onClick={this.handleStartTour}
                            sx={{
                                backgroundColor: '#8BC34A',
                                '&:hover': { backgroundColor: '#7cb342' },
                                textTransform: 'none',
                                fontWeight: 600,
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            {intl.formatMessage({ id: 'onboarding.welcome.btn.start' })}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    userSession: state.userSession,
    onboarding: state.onboarding,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ markWelcomeSeen, openChecklist, startTour }, dispatch);

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(WelcomeModal)));
